<template>
  <div class="teldetyhpj">
    <div class="row_title">用户评价</div>
    <div class="content">
      <div class="rat_item between" v-for="item in 4" :key="item">
        <div class="userinfo flex_start">
          <div class="usercover">
            <img src="../../../assets/telzx/aaaa1_sample.png" alt="" />
          </div>
          <div class="dec">
            <div class="ui1 ellipsis">用户188******81</div>
            <div class="ui2 ellipsis">
              专业，是个值得信赖的律师专业，是个值得信赖的律师专业，是个值得信赖的律师专业，是个值得信赖的律师
            </div>
            <div class="ui3 ellipsis">3小时前</div>
          </div>
        </div>
        <div>
          <el-rate v-model="value" disabled> </el-rate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    value: 4,
  }),
  mounted() {
    console.log(this);
  },
};
</script>

<style lang="scss" scoped>
.teldetyhpj {
  .row_title {
    font-size: 24px;
    line-height: 22px;
    color: #333333;
  }
  .content {
    margin-top: 30px;
    width: 100%;
    height: 614px;
    box-shadow: 0px 0px 10px 0px rgba(38, 38, 38, 0.08);
    padding: 8px 25px 0;
    .rat_item {
      align-items: flex-start;
      padding: 32px 0;
      border-bottom: 1px solid #eeeeee;
      &:last-child {
        border-bottom: none;
      }
      .userinfo {
        align-items: flex-start;
        .usercover {
          margin-right: 16px;
          img {
            width: 66px;
            height: 66px;
            border-radius: 50%;
          }
        }
        .dec {
          width: 560px;
          .ui1 {
            font-size: 16px;
            color: #666666;
            line-height: 16px;
          }
          .ui2 {
            margin-top: 22px;
            font-size: 18px;
            color: #333333;
            line-height: 18px;
          }
          .ui3 {
            margin-top: 17px;
            font-size: 14px;
            color: #999999;
            line-height: 14px;
          }
        }
      }
    }
  }
}
</style>